import { style } from "@vanilla-extract/css";

export const elementAvatarButton = style({
  paddingBlockStart: "4.17%",
  paddingInline: "12.5%",
});
